<script lang="ts">
  export default defineComponent({
    props: {
      size: {
        type: Number,
        default: undefined,
      },
    },
    setup(props) {
      return {
        currentSize: computed(() => (props.size ? `${props.size}px` : '100%')),
      };
    },
  });
</script>

<template>
  <svg
    :style="{ width: currentSize, height: currentSize }"
    class="site-logo"
    fill="none"
    viewBox="0 0 1000 1000"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- eslint-disable max-len, vue/max-len -->
    <path
      d="M459.1 987.66L101.38 756.96C79.32 742.73 66 718.28 66 692.03L66 319.45C66 293.77 78.76 269.76 100.07 255.4L457.78 14.2C483.9 -3.41 518.09 -3.41 544.21 14.2L901.93 255.4C923.23 269.76 936 293.77 936 319.45L936 692.03C936 718.28 922.67 742.73 900.61 756.96L542.89 987.66C517.38 1004.11 484.61 1004.11 459.1 987.66Z"
      fill="var(--logo-stroke)"
      fill-rule="evenodd"
    />

    <path
      d="M701.31 281.26C708.97 281.26 713.07 272.25 708.02 266.48L524.49 56.7C512.05 42.49 489.93 42.49 477.5 56.7L293.96 266.48C288.92 272.25 293.01 281.26 300.68 281.26L701.31 281.26Z"
      fill="var(--logo-section-2)"
      fill-rule="evenodd"
    />

    <path
      d="M616.01 111.67L763.97 280.78L850.44 275.28C857.04 274.85 859.36 266.31 853.87 262.61L621.21 105.77C617.36 103.18 612.96 108.17 616.01 111.67Z"
      fill="var(--logo-section-4)"
      fill-rule="evenodd"
    />

    <path
      d="M148.12 262.61C142.63 266.31 144.95 274.85 151.55 275.27L238.02 280.78L385.98 111.66C389.03 108.17 384.63 103.18 380.78 105.77L148.12 262.61Z"
      fill="var(--logo-section-1)"
      fill-rule="evenodd"
    />

    <path
      d="M114.99 593.5L216.85 325.68C219.34 319.14 214.78 312.05 207.79 311.61L125.57 306.37C111.01 305.44 98.69 316.99 98.69 331.57L98.69 590.51C98.69 599.85 111.66 602.24 114.99 593.5Z"
      fill="var(--logo-section-1)"
      fill-rule="evenodd"
    />

    <path
      d="M903.3 590.51L903.3 331.57C903.3 316.99 890.98 305.44 876.43 306.37L794.2 311.61C787.21 312.05 782.65 319.14 785.14 325.68L887 593.5C890.33 602.24 903.3 599.85 903.3 590.51Z"
      fill="var(--logo-section-8)"
      fill-rule="evenodd"
    />

    <path
      d="M443.42 722.05C455.88 722.51 463.96 709.08 457.72 698.29L264.24 363.53C257.77 352.34 241.19 353.67 236.59 365.76L115.55 683.97C110.73 696.65 119.8 710.31 133.36 710.81L443.42 722.05Z"
      fill="var(--logo-section-3)"
      fill-rule="evenodd"
    />

    <path
      d="M868.63 710.81C882.19 710.31 891.26 696.65 886.43 683.98L765.4 365.76C760.8 353.67 744.22 352.34 737.75 363.53L544.27 698.29C538.03 709.08 546.11 722.51 558.57 722.05L868.63 710.81Z"
      fill="var(--logo-section-6)"
      fill-rule="evenodd"
    />

    <path
      d="M450.27 943.09C465.1 952.65 484.65 942.01 484.65 924.36L484.65 798.27C484.65 774.83 466.08 755.58 442.63 754.73L159.18 744.45C154.15 744.27 152.08 750.83 156.31 753.56L450.27 943.09Z"
      fill="var(--logo-section-5)"
      fill-rule="evenodd"
    />

    <path
      d="M517.34 924.36C517.34 942.01 536.89 952.65 551.72 943.09L845.68 753.55C849.91 750.83 847.85 744.26 842.81 744.44L559.36 754.73C535.91 755.58 517.34 774.82 517.34 798.27L517.34 924.36Z"
      fill="var(--logo-section-7)"
      fill-rule="evenodd"
    />

    <path
      d="M491.2 638.78L500.99 638.78L510.79 638.78C529.15 638.78 546.18 629.2 555.7 613.5L575.75 580.42C578.51 575.87 574.35 570.27 569.19 571.59L553.64 575.57C551.6 576.09 549.9 577.51 549.04 579.43L541.62 595.83C540.84 597.56 539.23 598.76 537.36 599.03C533.64 599.55 530.49 596.28 531.16 592.58L532.61 584.56C533.38 580.31 530.11 576.4 525.78 576.4L515.26 576.4C511.43 576.4 508.32 579.5 508.32 583.33L508.32 593.15C508.32 596.98 505.22 600.09 501.39 600.09L500.6 600.09C496.77 600.09 493.66 596.98 493.66 593.15L493.66 583.33C493.66 579.5 490.55 576.4 486.72 576.4L476.2 576.4C471.88 576.4 468.61 580.31 469.37 584.56L470.83 592.58C471.5 596.28 468.35 599.55 464.62 599.03C462.75 598.76 461.14 597.56 460.36 595.83L452.95 579.43C452.08 577.51 450.39 576.09 448.35 575.57L432.79 571.59C427.63 570.27 423.47 575.87 426.23 580.42L446.28 613.5C455.8 629.2 472.83 638.78 491.2 638.78ZM353.93 332.25L326.16 365.4C318.15 374.96 316.97 388.52 323.21 399.33L373.04 485.54C378.58 495.12 388.92 500.91 399.99 500.62L406.84 500.45C421.18 500.08 431.59 513.99 427.17 527.64L422.48 542.11C421.07 546.47 423.64 551.12 428.09 552.24L439.95 555.22C444.17 556.28 448.45 553.76 449.56 549.55L456.07 524.78C457.38 519.82 461.86 516.36 467 516.36C470.35 516.36 472.85 519.46 472.15 522.74L466.39 549.42C465.51 553.51 468.43 557.44 472.6 557.79L486.55 558.94C490.59 559.28 494.06 556.09 494.06 552.03L494.06 523.29C494.06 519.46 497.16 516.36 500.99 516.36C504.82 516.36 507.93 519.46 507.93 523.29L507.93 552.03C507.93 556.09 511.39 559.28 515.43 558.94L529.38 557.79C533.56 557.44 536.47 553.51 535.59 549.42L529.84 522.74C529.13 519.46 531.63 516.36 534.99 516.36C540.12 516.36 544.61 519.82 545.91 524.78L552.43 549.55C553.53 553.76 557.82 556.28 562.03 555.22L573.9 552.24C578.34 551.12 580.91 546.47 579.5 542.11L574.81 527.64C570.4 513.99 580.8 500.08 595.15 500.45L602 500.62C613.07 500.91 623.4 495.12 628.94 485.54L678.77 399.33C685.02 388.52 683.84 374.96 675.82 365.4L648.05 332.25C642.4 325.5 634.06 321.61 625.26 321.61L500.99 321.61L376.73 321.61C367.93 321.61 359.58 325.5 353.93 332.25ZM502.53 469.95L501.41 467.95C501.22 467.61 500.73 467.61 500.54 467.95L499.42 469.95C498.55 471.51 496.89 472.48 495.1 472.48L483.34 472.48C479.43 472.48 477.06 468.15 479.18 464.85L497.64 436.12C499.2 433.7 502.75 433.7 504.31 436.12L522.77 464.85C524.89 468.15 522.53 472.48 518.61 472.48L506.85 472.48C505.06 472.48 503.41 471.51 502.53 469.95ZM572.13 442.77C544.13 442.77 521.42 422.92 521.42 398.43C521.42 373.94 544.13 354.09 572.13 354.09L618.79 354.09C639.76 354.09 651.24 378.51 637.86 394.64L612.11 425.71C602.83 436.1 588.37 442.77 572.13 442.77ZM429.85 442.77C457.86 442.77 480.56 422.92 480.56 398.43C480.56 373.94 457.86 354.09 429.85 354.09L383.19 354.09C362.22 354.09 350.74 378.51 364.12 394.64L389.87 425.71C399.16 436.1 413.61 442.77 429.85 442.77Z"
      fill="var(--logo-skull)"
      fill-rule="evenodd"
    />
    <!-- eslint-enable max-len, vue/max-len -->
  </svg>
</template>

<style lang="scss" scoped>
  .site-logo {
    overflow: hidden;
    display: block;
    flex-shrink: 0;
  }
</style>
